import React from 'react';
import { makeStyles, Typography } from '@material-ui/core';
import useCommonStyles from './useCommonStyles';
import clsx from 'clsx';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  root: {
    ...theme.typography.subtitle3,
  },
  active: {
    color: theme.palette.colorsPalette.TrueGreen,
  },
  inactive: {
    color: theme.palette.neutrals[5],
  },
}));

const Subtitle3 = ({ children, center, right, active, inactive, oneLine, className, ...props }) => {
  const classes = useStyles();
  const common = useCommonStyles();

  return (
    <Typography
      variant="subtitle2"
      classes={{ root: classes.root }}
      className={clsx({
        [common.center]: center,
        [common.right]: right,
        [classes.active]: active,
        [classes.inactive]: inactive,
        [common.wrapEllipsis]: oneLine,
        [className]: className.length > 0,
      })}
      {...props}
    >
      {children}
    </Typography>
  );
};

Subtitle3.defaultProps = {
  center: false,
  right: false,
  active: false,
  inactive: false,
  oneLine: false,
  className: '',
};

Subtitle3.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.array]).isRequired,
  center: PropTypes.bool,
  right: PropTypes.bool,
  active: PropTypes.bool,
  inactive: PropTypes.bool,
  oneLine: PropTypes.bool,
  className: PropTypes.string,
};

export default Subtitle3;
